import * as angular from 'angular';

import { StorageService } from '../../shared';

export class DemoService {
    static readonly $inject = ['$window', 'fcStorageService'];

    private modal: JQuery;

    private id: string;
    private name: string;
    private email: string;
    private demo: boolean;
    private hide: boolean;

    private readonly shownValue = 'shown';

    constructor(
        private readonly window: angular.IWindowService,
        private readonly storageService: StorageService
    ) {}

    init(id: string, demo: boolean, name: string, email: string): void {
        this.id = id;
        this.name = name;
        this.email = email;
        this.demo = demo;

        // Hide if not a demo or the storage value is not set
        const storageKey = this.getStorageKey(this.id);
        this.hide = !demo || this.storageService.get(storageKey) === this.shownValue;
    }

    active(): boolean {
        return this.demo;
    }

    reset(): void {
        // Clear all known demos
        for (const id of ['modeler', 'stochastic', 'tracker']) {
            const storageKey = this.getStorageKey(id);
            this.storageService.set(storageKey, null);
        }
    }

    showModal(): void {
        if (this.id && !this.hide) {
            const element = angular.element(`#fc-${this.id}-demo-modal`);
            const plugin = element.data('zfPlugin');

            // Need to wait for foundation to render the modal
            // This is done by checking the element for plugin data
            if (plugin && !this.modal) {
                this.modal = element;
                this.modal.on('closed.zf.reveal', () => {
                    const storageKey = this.getStorageKey(this.id);
                    this.storageService.set(storageKey, this.shownValue);
                    this.hide = true;
                });

                this.modal.foundation('open');
            }
        }
    }

    canShowModal(): boolean {
        return !this.hide;
    }

    sendContact(): void {
        if (this.id && this.name && this.email) {
            const body = encodeURIComponent(`Name: ${this.name}\r\nEmail: ${this.email}`);
            this.window.location.href = `mailto:futurecost@milliman.com?subject=${this.id}&body=${body}`;
        }
    }

    private getStorageKey(id: string): string {
        return `${id}__demo-contact`;
    }
}
